shadow$provide[322] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Renderable:{enumerable:true, get:function() {
  return Renderable;
}}});
class Renderable {
  constructor(renderer, shaders) {
    this.renderer = renderer;
    this.shaders = shaders;
    this.gl = this.renderer.getContext();
    if (this.uniforms == null) {
      this.uniforms = {};
    }
  }
  dispose() {
    this.uniforms = null;
  }
  _adopt(uniforms) {
    for (const key in uniforms) {
      const value = uniforms[key];
      this.uniforms[key] = value;
    }
  }
  _set(uniforms) {
    for (const key in uniforms) {
      const value = uniforms[key];
      if (this.uniforms[key] != null) {
        this.uniforms[key].value = value;
      }
    }
  }
}

};